import { OptionSelect, Person, Survey, TextPermissions } from '@/types/common';
import Vue from 'vue';
import {
  BOOKER,
  HEARD_FROM,
  PLAYER,
  MINORS,
  OCCASION,
  PERSON,
  RESERVATIONS,
  SELECTED_RESERVATION,
  SIGNATURE,
  SMS_OPTIN,
  State,
  SURVEYS,
  SURVEY_ANSWERS,
  TAGS,
  GUARDIAN,
  SURVEY_FOLLOW_UP_RANDOM_NUMBER
} from "./state";

// TODO: refactor to this: https://dev.to/3vilarthas/vuex-typescript-m4j
export const UPDATE_BOOKER                = 'updateBooker';
export const UPDATE_GUARDIAN              = 'updateGuardian';
export const UPDATE_HEARD_FROM            = 'updateHeardFrom';
export const UPDATE_PLAYER                = 'updatePlayerType';
export const UPDATE_MINORS                = 'updateMinors';
export const UPDATE_OCCASION              = 'updateOccasion';
export const UPDATE_PERSON                = 'updatePerson';
export const UPDATE_RESERVATIONS          = 'updateReservations';
export const UPDATE_SELECTED_RESERVATION  = 'updateSelectedReservation';
export const UPDATE_SIGNATURE             = 'updateSignature';
export const UPDATE_SMS_OPTIN             = 'updateSmsOptin';
export const UPDATE_SURVEY_ANSWERS        = 'updateSurveyAnswers';
export const UPDATE_SURVEYS               = 'updateSurveys';
export const UPDATE_TAGS                  = 'updateTags';
export const GENERATE_RNG                 = 'updateSurveyFollowUpRandomNumber';

export default {
  [UPDATE_BOOKER]: (state: State, booker: Record<string, any>) => {
    state[BOOKER] = booker;
  },

  [UPDATE_GUARDIAN]: (state: State, isGuardian: boolean) => {
    state[GUARDIAN] = isGuardian;
  },

  [UPDATE_HEARD_FROM]: (state: State, { id, detail }: Record<string, any>) => {
    state[HEARD_FROM] = Object.assign({}, state[HEARD_FROM], { id, detail })
  },

  [UPDATE_MINORS]: (state: State, minors: Record<string, any>[]) => {
    state[MINORS] = minors;
  },

  [UPDATE_OCCASION]: (state: State, occasionDetails: OptionSelect) => {
    state[OCCASION] = occasionDetails;
  },

  [UPDATE_PERSON]: (state: State, person: Person) => {
    state[PERSON] = person;
  },

  [UPDATE_PLAYER]: (state: State, playerId: number) => {
    state[PLAYER] = playerId;
  },

  [UPDATE_RESERVATIONS]: (state: State, reservations: Record<string, any>[]) => {
    Vue.set(state, RESERVATIONS, reservations);
  },

  [UPDATE_SELECTED_RESERVATION]: (state: State, reservation: any) => {
    Vue.set(state, SELECTED_RESERVATION, reservation);
  },

  [UPDATE_SIGNATURE]: (state: State, signature: any) => {
    state[SIGNATURE] = signature;
  },

  [UPDATE_SMS_OPTIN]: (state: State, optin: TextPermissions) => {
    state[SMS_OPTIN] = optin;
  },

  [UPDATE_SURVEY_ANSWERS]: (state: State, answers: Survey[]) => {
    state[SURVEY_ANSWERS] = answers;
  },

  [UPDATE_SURVEYS]: (state: State, surveys: Record<string, any>) => {
    const normalizedSurveys = (state[SURVEYS]) 
      ? surveys
      : surveys;

    Vue.set(state, SURVEYS, normalizedSurveys);
  },

  [UPDATE_TAGS]: (state: State, tags: Record<string, any>[]) => {
    const normalizedTags = (state[TAGS]) // NOTE: only normalize once per app load
      ? tags
      : normalizeTags(tags)
    Vue.set(state, TAGS, normalizedTags);
  },

  [GENERATE_RNG]: (state: State) => {
    state[SURVEY_FOLLOW_UP_RANDOM_NUMBER] = Math.floor(Math.random() * 3);
  }
}

// @ts-ignore
const normalizeSurveys = ({ Survey_set_questions }) => {
  let BLACKLIST: any;
  try {
    BLACKLIST = JSON.parse(process.env.VUE_APP_SURVEY_QUESTIONS_BLACKLIST);
  } catch (err) {
    BLACKLIST = { "1": [9, 10, 18], "2": [], "3": [] };
  }
  // @ts-ignore
  return Survey_set_questions.reduce((acc, { id, Survey_question, Survey_set_questions_answer_options, ...rest }) => {
    // @ts-ignore
    const filteredAnswers = Survey_set_questions_answer_options.filter(answerObj => !BLACKLIST[id].includes(answerObj.id));
    return [
      ...acc,
      {
        Survey_question,
        Survey_set_questions_answer_options: filteredAnswers,
        ...rest
      }
    ];
  }, []);
}

// @ts-ignore
const normalizeTags = (tags) => {
  let BLACKLIST: number[];
  try {
    BLACKLIST = JSON.parse(process.env.VUE_APP_TAGS_BLACKLIST);
  } catch (err) {
    BLACKLIST = [8,10,11,12,13];
  }
    // NOTE: reformat tags to be just { id, name }
    // @ts-ignore
    return tags.reduce((acc, { id, name }) => { 
      if (BLACKLIST.includes(id)) return acc; // NOTE: remove the ids you don't want
      return [
        ...acc,
        {
          name,
          id 
        } 
      ]
    }, []);
}